import { supabase } from "../services/supabaseClient";

export type OperationsReadSource = {
  id: string;
  repository: "EXPLORE" | "GIFTSHOP";
  category:
    | "incidents"
    | "errors"
    | "queues"
    | "refunds";
  source_name: string;
  status: "ready" | "unavailable";
  total: number | null;
  error_code: string | null;
};

export type OperationsReadModel = {
  ok: true;
  mode: "read_only";
  repository: "EXPLORE" | "GIFTSHOP";
  generated_at: string;
  window_hours: number;
  totals: {
    sources: number;
    ready_sources: number;
    unavailable_sources: number;
    events: number;
  };
  sources: OperationsReadSource[];
};

export async function fetchOperationsReadModel(
  windowHours = 24,
): Promise<OperationsReadModel> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    throw new Error("admin_session_required");
  }

  const { data, error } =
    await supabase.functions.invoke(
      "admin-operations-read",
      {
        body: {
          window_hours: windowHours,
        },
        headers: {
          Authorization:
            `Bearer ${session.access_token}`,
        },
      },
    );

  if (error) {
    throw new Error(
      error.message ||
      "operations_read_model_unavailable",
    );
  }

  if (!data?.ok) {
    throw new Error(
      data?.error ||
      "operations_read_model_rejected",
    );
  }

  return data as OperationsReadModel;
}
